import { render, staticRenderFns } from "./ExamKDR.vue?vue&type=template&id=674817dd&"
import script from "./ExamKDR.vue?vue&type=script&lang=js&"
export * from "./ExamKDR.vue?vue&type=script&lang=js&"
import style0 from "./ExamKDR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports